export type ProfileError = { error: string; [properties: string]: any };
export type ProfileErrors = Record<string, ProfileError | undefined>;

export function transformProfileErrors(errors: any): ProfileErrors {
  if (errors === undefined) {
    return {};
  }
  const tmp = JSON.parse(JSON.stringify(errors));
  const formErrors = {};

  if (tmp.properties?.length) {
    Object.assign(formErrors, tmp.properties[0].error);
    delete tmp.properties;
  }

  Object.assign(formErrors, tmp);

  Object.keys(formErrors).forEach(property => {
    const error = formErrors[property][0].error;
    formErrors[property] = {
      ...formErrors[property][0],
      error: error === 'invalid' ? `${error}_${property}` : error,
    };
  });

  return formErrors;
}
